<script lang="ts">
    import { _ } from "svelte-i18n"
    import { Splide, SplideSlide, SplideTrack } from "@splidejs/svelte-splide"
    import { sliderImageCursor, currentColorTheme } from "../../store"

    import ProjectTile from "./ProjectTile.svelte"

    export let contents: Content[]

    $: projects = contents
        .filter((c) => {
            return c?.type?.includes("project") && c?.project?.general?.currentProjectsSlider
        })
        .sort((a, b) => {
            const dateA = new Date(a.project?.general?.date || 0)
            const dateB = new Date(b.project?.general?.date || 0)
            return dateB.getTime() - dateA.getTime()
        })

    let scrollY: number = 0
    let isOver: boolean = false
    let posX: number = 0
    let posY: number = 0

    const onMouseMove = (e) => {
        if (isOver) {
            posX = e.clientX
            posY = e.clientY
            $sliderImageCursor.element.style.top = posY + scrollY - 40 + "px"
            $sliderImageCursor.element.style.left = posX - 64 + "px"
        }
    }

    const onMouseLeave = (e) => {
        isOver = false
        $sliderImageCursor.element.style.top = "-999px"
        $sliderImageCursor.element.style.left = "-999px"
        $sliderImageCursor.element.classList.remove("show")
    }

    const onMouseEnter = (e) => {
        if (!isOver) {
            if ($currentColorTheme === "dark") {
                $sliderImageCursor.theme = "default"
            } else {
                $sliderImageCursor.theme = "dark"
            }
            $sliderImageCursor.element.classList.add("show")
        }
        isOver = true
    }

    const onScroll = (e) => {
        if (isOver) {
            $sliderImageCursor.element.style.top = posY + scrollY - 40 + "px"
            $sliderImageCursor.element.style.left = posX - 64 + "px"
        }
    }
</script>

<svelte:window bind:scrollY on:scroll="{onScroll}" />

<section
    class="current-projects-slider-section"
    on:mouseenter="{onMouseEnter}"
    on:mouseleave="{onMouseLeave}"
    on:mousemove="{onMouseMove}"
>
    <section class="wm-container full">
        <h2>{$_("current-projects")}</h2>
    </section>

    <Splide
        class="current-projects-slider"
        aria-label="Current Projects - Slider"
        options="{{
            padding: '20px',
            pagination: false,
            fixedWidth: '23vw',
            gap: '78px',
            arrows: false,
            perPage: 0,
            breakpoints: {
                1240: {
                    fixedWidth: '38vw',
                },
                768: {
                    fixedWidth: '60vw',
                },
                450: {
                    fixedWidth: '60vw',
                    perPage: 1,
                },
            },
        }}"
        hasTrack="{false}"
    >
        <div class="custom-wrapper">
            <SplideTrack>
                {#each projects as p, index}
                    <SplideSlide>
                        <ProjectTile project="{p}" show="{true}" />
                    </SplideSlide>
                {/each}
                <SplideSlide />
            </SplideTrack>
        </div>
    </Splide>
</section>
